import React from "react";
import modal from "components/Modal/ModalContent.module.css";
import { Button } from "components/Button/Button";
import { Modal } from "components/Modal/Modal";
import { Owner } from "lib/entries/types";

interface Props {
  matViewName: string;
  children: React.ReactElement;
  newOwner: Pick<Owner, "type" | "id" | "handle">;
  onChangeOwner: () => void;
}

export function QueryOwnershipChangeWithMatView(props: Props) {
  const { matViewName, children, newOwner } = props;

  function Content({ close }: { close: () => void }) {
    return (
      <div className={modal.body}>
        <div className={modal.header}>
          <div className={modal.titleRow}>
            <h2>
              Changing ownership will break queries that rely on this query's
              materialized view
            </h2>
          </div>

          <p className={modal.description}>
            Materialized view's alias will change from current owner's handle to
            the new one:{" "}
            <strong>
              {newOwner.handle}_{matViewName}
            </strong>
            .
            <br />
            <span>
              {/* TODO: Ensure we fill this with the correct number of affected queries */}
              This change will affect X queries, you'll need to manually update
              them after.
            </span>
          </p>
        </div>
        <div className={modal.buttons}>
          <Button size="M" theme="tertiary" onClick={close}>
            Back
          </Button>
          <Button size="M" theme="danger" onClick={props.onChangeOwner}>
            Change owner
          </Button>
        </div>
      </div>
    );
  }

  return (
    <Modal
      size="M"
      label="changing ownership query with mat view"
      content={Content}
      trigger={({ onClick }) => React.cloneElement(children, { onClick })}
    />
  );
}
